import { memo } from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'

/**
 * @param title {string}
 * @param toggleMenu
 * @param showMenu {boolean}
 * @param corner {object|boolean} If false, won't render anything at the end; if null, renders the default search button
 */
function Header({ title, toggleMenu, showMenu = true, corner = null }) {
	return <>
		<header>
			<Container>
				<Row>
				{showMenu && <Col xs="auto" id="menu-button-col" className="pr-0 d-print-none">
					<Button onClick={toggleMenu} title="Menu" className="px-0">
						<FontAwesomeIcon icon="bars" className="ml-0"/>
					</Button>
				</Col>}

				<Col as="h1" className="ml-0">{title}</Col>
				<Col xs="auto" className="pl-0 d-print-none">{corner}</Col>{/* TODO: could we remove the col when there's no content? */}
				</Row>
			</Container>
		</header>
	</>
}

Header.propTypes = {
	title     : PropTypes.node.isRequired,
	toggleMenu: PropTypes.func.isRequired,
	corner    : PropTypes.oneOfType([PropTypes.node, PropTypes.bool]),
}

export default memo(Header)
